import PropTypes from 'prop-types';
import styled from 'styled-components';
import mediaQueries from './constants/mediaQueries';

const SectionWrap = styled.section`
  background-color: ${props => props.backgroundColor};
  padding: 0 24px;

  ${mediaQueries.desktop`
    padding: 0 40px;
  `}
`;

SectionWrap.propTypes = {
  backgroundColor: PropTypes.string,
};

export default SectionWrap;
